"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _underscore = require("underscore");

var _reactRedux = require("react-redux");

var _DynoEditor = require("lead-flows-ui/actions/DynoEditor");

var _Dynos = require("lead-flows-ui/selectors/Dynos");

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIButtonGroup = _interopRequireDefault(require("UIComponents/button/UIButtonGroup"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIPreviousButton = _interopRequireDefault(require("UIComponents/button/UIPreviousButton"));

var _UINextButton = _interopRequireDefault(require("UIComponents/button/UINextButton"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _UIDeviceFrame = _interopRequireDefault(require("UIComponents/device/UIDeviceFrame"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _DynoEditor2 = require("lead-flows-ui/constants/DynoEditor");

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

var _DynoEditorDemoIframe = _interopRequireDefault(require("./DynoEditorDemoIframe"));

var _DynoPreviewCarouselSteps = _interopRequireDefault(require("./DynoPreviewCarouselSteps"));

var _DynoEditorDemoEmail = _interopRequireDefault(require("./DynoEditorDemoEmail"));

var PREVIEW_DYNO_STATES_NO_CLOSED = (0, _underscore.filter)(_DynoEditor2.PREVIEW_DYNO_STATES, function (state) {
  return state !== 'CLOSED';
});
var DEMO_STATE_TO_ANALYTICS_INTERACTION = {
  closed: 'close-lead-flow',
  dismissed: 'dismiss-lead-flow',
  form: 'view-form',
  preview: 'view-callout',
  thanks: 'view-thank-you'
};

var DynoEditorFullDemo = _react.default.createClass({
  displayName: "DynoEditorFullDemo",
  propTypes: {
    updateDyno: _react.default.PropTypes.func.isRequired,
    dyno: _react.default.PropTypes.object.isRequired,
    domain: _react.default.PropTypes.string.isRequired,
    fetchKickbacks: _react.default.PropTypes.func.isRequired,
    kickbackPreviews: _react.default.PropTypes.array,
    isFetchingPreviews: _react.default.PropTypes.bool,
    previewServerResponse: _react.default.PropTypes.object,
    validation: _react.default.PropTypes.object.isRequired,
    hasForm: _react.default.PropTypes.bool
  },
  getInitialState: function getInitialState() {
    return {
      selectedDemoView: _DynoEditor2.PREVIEW_TYPES.DESKTOP,
      demoState: _DynoEditor2.PREVIEW_DYNO_STATES.PREVIEW,
      topIndex: 0,
      mailIndex: 0,
      iframeIsLoading: false,
      topCount: PREVIEW_DYNO_STATES_NO_CLOSED.length
    };
  },
  componentWillMount: function componentWillMount() {
    var _this$props$dyno = this.props.dyno,
        kickbackEmails = _this$props$dyno.kickbackEmails,
        portalId = _this$props$dyno.portalId,
        locale = _this$props$dyno.locale;
    var _this$props = this.props,
        fetchKickbacks = _this$props.fetchKickbacks,
        validation = _this$props.validation;

    if (!validation['follow-up']) {
      fetchKickbacks(portalId, kickbackEmails, locale);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.kickbackPreviews !== this.props.kickbackPreviews) {
      this.setState({
        topCount: PREVIEW_DYNO_STATES_NO_CLOSED.length + nextProps.kickbackPreviews.length
      });
    }
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.fullDemo." + suffix;
  },
  getDesktopWidth: function getDesktopWidth() {
    var desktopScreensSizes = [1280, 1024, 960];
    var available = (0, _underscore.filter)(desktopScreensSizes, function (value) {
      return window.innerWidth - 60 > value;
    });

    if (available.length > 0) {
      return available[0];
    }

    return 960;
  },
  getScreenSizeOptions: function getScreenSizeOptions(selectedDemoView) {
    var desktopWidth = this.getDesktopWidth();

    switch (selectedDemoView) {
      case _DynoEditor2.PREVIEW_TYPES.DESKTOP:
        return {
          typeClass: 'dyno-full-demo--desktop',
          width: desktopWidth,
          height: 720
        };

      case _DynoEditor2.PREVIEW_TYPES.TABLET:
        return {
          typeClass: 'dyno-full-demo--tablet',
          width: 768,
          height: 1024,
          deviceName: 'Apple iPad'
        };

      case _DynoEditor2.PREVIEW_TYPES.MOBILE:
        return {
          typeClass: 'dyno-full-demo--mobile',
          width: 375,
          height: 647,
          deviceName: 'Apple iPhone 6'
        };

      default:
        LOG.error("Unknown dyno editor demo type: " + selectedDemoView); // fallback to desktop type anyway so we don't break the render

        return {
          typeClass: "dyno-full-demo--desktop-" + desktopWidth,
          width: desktopWidth,
          height: 720
        };
    }
  },
  updatePreviewMode: function updatePreviewMode(mode) {
    this.setState({
      selectedDemoView: mode,
      demoState: _DynoEditor2.PREVIEW_DYNO_STATES.PREVIEW,
      mailIndex: 0,
      topIndex: 0
    });
    var modeString;

    switch (mode) {
      case _DynoEditor2.PREVIEW_TYPES.DESKTOP:
        modeString = 'DESKTOP';
        break;

      case _DynoEditor2.PREVIEW_TYPES.TABLET:
        modeString = 'TABLET';
        break;

      case _DynoEditor2.PREVIEW_TYPES.MOBILE:
        modeString = 'MOBILE';
        break;

      default:
        LOG.error("Unknown dyno editor demo mode " + mode);
        modeString = 'UNKOWN';
        break;
    }

    (0, _eventsTrackerUtils.trackEditorInteraction)('demo-interaction', {
      demoInteraction: "switch-to-" + modeString.toLowerCase()
    });
  },
  getUpdatedTopIndex: function getUpdatedTopIndex(newState) {
    var previewStates = Object.keys(_DynoEditor2.PREVIEW_DYNO_STATES);
    return previewStates.indexOf(newState);
  },
  isValidTopIndex: function isValidTopIndex(index) {
    var hasForm = this.props.hasForm;
    var topCount = hasForm ? this.state.topCount : 1;
    return index < topCount && index >= 0;
  },
  isMailIndex: function isMailIndex(index) {
    var previewStatesCount = PREVIEW_DYNO_STATES_NO_CLOSED.length;
    return index >= previewStatesCount;
  },
  incrementTopIndexHandler: function incrementTopIndexHandler() {
    var topIndex = this.state.topIndex;
    var newTopIndex = topIndex + 1;
    var states = Object.keys(_DynoEditor2.PREVIEW_DYNO_STATES);
    var isMailIndex = this.isMailIndex(topIndex);
    var loading = this.state.iframeIsLoading;

    if (!this.isValidTopIndex(newTopIndex) || loading && !isMailIndex) {
      return;
    }

    if (isMailIndex) {
      this.setState(function (prevState) {
        return {
          mailIndex: prevState.mailIndex + 1,
          topIndex: prevState.topIndex + 1
        };
      });
    } else {
      this.updateDemoState(states[newTopIndex]);
    }
  },
  decrementTopIndexHandler: function decrementTopIndexHandler() {
    var newTopIndex = this.state.topIndex - 1;
    var states = Object.keys(_DynoEditor2.PREVIEW_DYNO_STATES);

    if (!this.isValidTopIndex(newTopIndex)) {
      return;
    }

    if (!this.isMailIndex(newTopIndex)) {
      this.updateDemoState(states[newTopIndex]);
    } else {
      this.setState(function (prevState) {
        return {
          mailIndex: prevState.mailIndex - 1,
          topIndex: prevState.topIndex - 1
        };
      });
    }
  },
  handleIframeLoadingState: function handleIframeLoadingState(loading) {
    this.setState({
      iframeIsLoading: loading
    });
  },
  updateDemoState: function updateDemoState(state) {
    var previousState = this.state.demoState;

    if (previousState !== state) {
      var updatedIndex = this.getUpdatedTopIndex(state);
      if (!this.isValidTopIndex(updatedIndex)) return;
      this.setState({
        demoState: state,
        mailIndex: 0,
        topIndex: updatedIndex
      });
      (0, _eventsTrackerUtils.trackEditorInteraction)('demo-interaction', {
        demoInteraction: DEMO_STATE_TO_ANALYTICS_INTERACTION[state] || 'unknown'
      });
    }
  },
  renderStateControlButtons: function renderStateControlButtons(type, displayOnMobile) {
    var topIndex = this.state.topIndex;
    var _this$props2 = this.props,
        kickbackPreviews = _this$props2.kickbackPreviews,
        validation = _this$props2.validation,
        hasForm = _this$props2.hasForm;
    var count = kickbackPreviews && !validation['follow-up'] ? kickbackPreviews.length : 0;

    if (type === _DynoEditor2.PREVIEW_TYPES.MOBILE && !displayOnMobile) {
      return null;
    }

    return _react.default.createElement(_DynoPreviewCarouselSteps.default, {
      hasForm: hasForm,
      activeStep: topIndex,
      mailCount: count
    });
  },
  renderDisplayOnMobileCheckbox: function renderDisplayOnMobileCheckbox(type, displayOnMobile, updateDyno) {
    if (type === _DynoEditor2.PREVIEW_TYPES.MOBILE) {
      return _react.default.createElement("div", {
        className: "dyno-full-demo__display-on-mobile"
      }, _react.default.createElement(_UICheckbox.default, {
        defaultChecked: !displayOnMobile,
        onChange: function onChange(_ref) {
          var checked = _ref.target.checked;
          return updateDyno({
            displayOnMobile: !checked
          });
        },
        value: !displayOnMobile
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('disableOnMobileDevices')
      })));
    }

    return null;
  },
  renderDisabledOnMobileWarning: function renderDisabledOnMobileWarning(type, displayOnMobile) {
    if (type === _DynoEditor2.PREVIEW_TYPES.MOBILE && !displayOnMobile) {
      return _react.default.createElement("div", {
        className: "dyno-full-demo__disabled-on-mobile"
      }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('disabledOnPhone')
      })), _react.default.createElement("span", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('enableUncheckMessage')
      })));
    }

    return null;
  },
  renderEmailLoading: function renderEmailLoading(screenSizeOptions) {
    return _react.default.createElement(_UILoadingSpinner.default, {
      className: "dyno-editor-demo-email",
      grow: true,
      minHeight: screenSizeOptions.height
    });
  },
  renderEmailFailed: function renderEmailFailed(responseCode) {
    var errorMessage = '';

    if (responseCode === 500) {
      errorMessage = this.langKey('troubleLoadingEmailMessageServer');
    }

    if (responseCode === 400) {
      errorMessage = this.langKey('troubleLoadingEmailMessageClient');
    }

    return _react.default.createElement("div", {
      className: "dyno-editor-demo-email"
    }, _react.default.createElement(_UIErrorMessage.default, {
      className: "dyno-editor-demo-email__error"
    }, _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('troubleLoadingEmail')
    })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: errorMessage
    }))));
  },
  renderEmail: function renderEmail() {
    var _this$state = this.state,
        selectedDemoView = _this$state.selectedDemoView,
        mailIndex = _this$state.mailIndex;
    var kickbackEmails = this.props.dyno.kickbackEmails;
    var _this$props3 = this.props,
        kickbackPreviews = _this$props3.kickbackPreviews,
        isFetchingPreviews = _this$props3.isFetchingPreviews,
        previewServerResponse = _this$props3.previewServerResponse;
    var sizeOptions = this.getScreenSizeOptions(selectedDemoView);

    if (previewServerResponse.isError) {
      return this.renderEmailFailed(previewServerResponse.responseCode);
    }

    if (isFetchingPreviews) {
      return this.renderEmailLoading(sizeOptions);
    }

    if (kickbackPreviews) {
      return _react.default.createElement(_DynoEditorDemoEmail.default, {
        kickbackEmails: kickbackEmails,
        currentIndex: mailIndex,
        kickbackPreviews: kickbackPreviews,
        demoView: selectedDemoView,
        screenSizeOptions: sizeOptions
      });
    }

    return this.renderEmailFailed();
  },
  renderPreview: function renderPreview() {
    var _this$state2 = this.state,
        demoState = _this$state2.demoState,
        selectedDemoView = _this$state2.selectedDemoView;
    var dyno = this.props.dyno;
    var showIframe = demoState !== _DynoEditor2.PREVIEW_DYNO_STATES.CLOSED;
    var demoContent = !showIframe && this.renderEmail();
    var changeKey = demoState === _DynoEditor2.PREVIEW_DYNO_STATES.CLOSED ? demoState : selectedDemoView;
    var deviceClass = "dyno-editor-demo-iframe-container-" + selectedDemoView;
    return _react.default.createElement(_UIDeviceFrame.default, {
      className: "dyno-editor-demo-iframe-container " + deviceClass,
      contentClassName: "dyno-editor-demo-iframe",
      type: selectedDemoView
    }, _react.default.createElement(_DynoEditorDemoIframe.default, {
      className: "full-demo-iframe",
      content: demoContent,
      dyno: dyno,
      handleStateChange: this.updateDemoState,
      key: changeKey,
      state: demoState,
      handleLoading: this.handleIframeLoadingState,
      showTryMe: true
    }));
  },
  renderExternalPreviewLink: function renderExternalPreviewLink() {
    var _this$props4 = this.props,
        dyno = _this$props4.dyno,
        domain = _this$props4.domain;
    return _react.default.createElement(_UITooltip.default, {
      title: _react.default.createElement(_FormattedMessage.default, {
        message: dyno.enabled ? this.langKey('testLinkTooltip') : this.langKey('testLinkDisabled')
      }),
      placement: "bottom right"
    }, _react.default.createElement(_UIButton.default, {
      disabled: !dyno.enabled,
      href: "http://" + domain + "/?hsLeadFlowPreview=" + dyno.id,
      use: "link",
      external: true
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('testLink')
    })));
  },
  renderDemoBox: function renderDemoBox(selectedDemoView, dyno, demoState, updateDyno) {
    var _this$getScreenSizeOp = this.getScreenSizeOptions(selectedDemoView),
        typeClass = _this$getScreenSizeOp.typeClass;

    var disabledOnMobileWarning = this.renderDisabledOnMobileWarning(selectedDemoView, dyno.displayOnMobile);
    var displayOnMobileCheckbox = this.renderDisplayOnMobileCheckbox(selectedDemoView, dyno.displayOnMobile, updateDyno);
    return _react.default.createElement("div", {
      className: "dyno-full-demo-container"
    }, _react.default.createElement("div", {
      className: (0, _classNames.default)('dyno-full-demo', typeClass)
    }, _react.default.createElement("div", {
      className: "dyno-full-demo__container"
    }, this.renderPreview(), disabledOnMobileWarning), displayOnMobileCheckbox));
  },
  renderCurrentTopIndex: function renderCurrentTopIndex() {
    var hasForm = this.props.hasForm;
    var topCount = hasForm ? this.state.topCount : 1;
    return _react.default.createElement("span", {
      className: "dyno-full-demo__top-index"
    }, this.state.topIndex + 1 + " / " + topCount);
  },
  renderNavigation: function renderNavigation() {
    var topIndex = this.state.topIndex;
    return _react.default.createElement("div", {
      className: "email-navigation-group"
    }, _react.default.createElement(_UIPreviousButton.default, {
      size: "small",
      onClick: this.decrementTopIndexHandler,
      disabled: !this.isValidTopIndex(topIndex - 1)
    }), this.renderCurrentTopIndex(), _react.default.createElement(_UINextButton.default, {
      size: "small",
      onClick: this.incrementTopIndexHandler,
      disabled: !this.isValidTopIndex(topIndex + 1)
    }));
  },
  render: function render() {
    var _this = this;

    var _this$props5 = this.props,
        dyno = _this$props5.dyno,
        updateDyno = _this$props5.updateDyno;
    var _this$state3 = this.state,
        selectedDemoView = _this$state3.selectedDemoView,
        demoState = _this$state3.demoState;
    var demoStateButtons = this.renderStateControlButtons(selectedDemoView, dyno.displayOnMobile);
    var demoBox = this.renderDemoBox(selectedDemoView, dyno, demoState, updateDyno);
    return _react.default.createElement("div", null, _react.default.createElement("div", {
      className: "dyno-full-demo__buttons"
    }, _react.default.createElement(_UIButtonGroup.default, null, _react.default.createElement(_UIButton.default, {
      size: "small",
      "data-preview-mode": "desktop",
      use: "tertiary-light",
      active: selectedDemoView === _DynoEditor2.PREVIEW_TYPES.DESKTOP,
      onClick: function onClick() {
        return _this.updatePreviewMode(_DynoEditor2.PREVIEW_TYPES.DESKTOP);
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('desktop')
    })), _react.default.createElement(_UIButton.default, {
      size: "small",
      "data-preview-mode": "tablet",
      use: "tertiary-light",
      active: selectedDemoView === _DynoEditor2.PREVIEW_TYPES.TABLET,
      onClick: function onClick() {
        return _this.updatePreviewMode(_DynoEditor2.PREVIEW_TYPES.TABLET);
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('tablet')
    })), _react.default.createElement(_UIButton.default, {
      size: "small",
      "data-preview-mode": "mobile",
      use: "tertiary-light",
      active: selectedDemoView === _DynoEditor2.PREVIEW_TYPES.MOBILE,
      onClick: function onClick() {
        return _this.updatePreviewMode(_DynoEditor2.PREVIEW_TYPES.MOBILE);
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('mobile')
    }))), this.renderExternalPreviewLink(), this.renderNavigation()), demoBox, demoStateButtons);
  }
});

function mapStateToProps(state) {
  return {
    kickbackPreviews: (0, _Dynos.getKickbackPreviews)(state),
    isFetchingPreviews: state.dynosEditor.editableDyno.isFetchingPreviews,
    previewServerResponse: state.dynosEditor.editableDyno.previewServerResponse,
    validation: state.dynosEditor.validation,
    hasForm: (0, _Dynos.getHasForm)(state)
  };
}

var actionsToBind = {
  fetchKickbacks: _DynoEditor.fetchKickbackPreviews
};

var _default = (0, _reactRedux.connect)(mapStateToProps, actionsToBind)(DynoEditorFullDemo);

exports.default = _default;
module.exports = exports.default;